import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const odedTrades: SeasonTrades[] = [
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.itay,
        sentAway: "Stephen Curry and Carmelo Anthony",
        gotInReturn: "Kyrie Irving and Patrick Patterson",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "David West and Ricky Rubio",
        gotInReturn: "Zach Randolph and Eric Gordon",
      },
    ],
  },

  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Brandon Jennings",
        gotInReturn: "Carlos Boozer",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Spencer Hawes",
        gotInReturn: "Kendall Marshall",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Chandler Parsons",
        gotInReturn: "Deron Williams",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Zach Randolph and Andre Iguodala",
        gotInReturn: "Rajon Rondo and Spencer Hawes",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Kyle Korver",
        gotInReturn: "Anderson Varejao",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Nicolas Batum",
        gotInReturn: "Ben McLemore",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Dirk Nowitzki",
        gotInReturn: "Al Jefferson",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Al Horford and Jeff Teague",
        gotInReturn: "Jimmy Butler",
        amongBestTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "Enes Kanter",
        gotInReturn: "Tony Snell",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Al Jefferson",
        gotInReturn: "Blake Griffin",
        amongBestTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Joakim Noah",
        gotInReturn: "Trey Burke",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Wesley Matthews",
        gotInReturn: "Deron Williams",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Otto Porter Jr",
        gotInReturn: "Frank Kaminsky",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "Kyle Korver and Jonas Valanciunas",
        gotInReturn: "Marc Gasol and Marcus Smart",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Alex Len and lower pick in Veterans Draft",
        gotInReturn: "Garry Harris and higher pick in Veterans Draft",
      },
    ],
  },
];
